import { CONTEXT_PATH, PAGE_DIFF_BY_VERSION } from '@confluence/named-routes';

import type {
	FeedCardAllActivityQuery_pageActivity_nodes as PageActivity,
	FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventUpdatedPage as PageActivity_UpdatedPage,
	FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventCreatedComment as PageActivity_CreatedComment,
} from './__types__/FeedCardAllActivityQuery';
import {
	PageActivityAction,
	PageActivityActionSubject,
} from './__types__/FeedCardAllActivityQuery';

const supportedUpdateTypes = {
	[PageActivityActionSubject.page]: {
		[PageActivityAction.created]: 'CREATE',
		[PageActivityAction.updated]: 'EDIT',
	},
	[PageActivityActionSubject.comment]: {
		[PageActivityAction.created]: 'COMMENT',
	},
};
type SupportedType = 'COMMENT' | 'CREATE' | 'EDIT' | undefined;
export const getSupportedUpdateType = (
	actionSubject: PageActivityActionSubject,
	action: PageActivityAction,
): SupportedType => {
	return supportedUpdateTypes[actionSubject]?.[action];
};

type Photo = {
	value: string | null;
	isPrimary: boolean | null;
};
type UserPhotos = (Photo | null)[] | null;
export const getAvatarUrl = (photos: UserPhotos): string => {
	return photos?.find((photo) => photo?.isPrimary)?.value || '';
};

export const getUpdateContentUrl = (
	activity: PageActivity,
	contentUrl: string,
	contentId: string,
): string => {
	const type = getSupportedUpdateType(activity.actionSubject, activity.action);
	if (type === 'COMMENT') {
		const commentLink = (activity as PageActivity_CreatedComment).comment.links.webui;
		if (commentLink) {
			return `${CONTEXT_PATH}${commentLink}`;
		}
	}

	if (type === 'CREATE') {
		return contentUrl;
	}

	if (type === 'EDIT') {
		const version = (activity as PageActivity_UpdatedPage).pageVersion;
		const params = {
			query: {
				pageId: contentId,
				selectedPageVersions: [version, version - 1],
			},
		};
		return PAGE_DIFF_BY_VERSION.toUrl({}, params);
	}

	return '';
};
